import {
  Flex,
  type GridRowSelectionModel,
  NoRowsOverlay,
  Text,
  DataGridWithCheckbox,
  BarChartIcon,
} from '@shared/components';
import { useState } from 'react';

import { columns, type UpdatePUseListItem } from './columns';

interface UpdatePUseListProps {
  onSelectRow?: (selectedPUseId: string | undefined) => void;
  rows: UpdatePUseListItem[];
}

export default function UpdatePUseList(props: Readonly<UpdatePUseListProps>) {
  const { onSelectRow, rows } = props;
  const defaultSelectedPUseId = rows.find((row) => row.selected)?.id || '';
  const [selectedPUseId, setSelectedPUseId] = useState<string>(defaultSelectedPUseId);

  const handleRowSelectionChange = (rowSelectionModel: GridRowSelectionModel) => {
    const selectedPUseIds = rowSelectionModel as string[];
    if (selectedPUseIds.length > 0) {
      const latestPUseId = selectedPUseIds[selectedPUseIds.length - 1];
      setSelectedPUseId(latestPUseId);
      onSelectRow?.(latestPUseId);
    } else {
      setSelectedPUseId('');
      onSelectRow?.(undefined);
    }
  };

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: (theme) => theme.spacing(3),
        p: (theme) => theme.spacing(6),
      }}
    >
      <Text variant='h4'>กรุณาเลือกค่า P 1 รายการเพื่อใช้งาน</Text>
      <DataGridWithCheckbox
        {...props}
        rowHeight={48}
        disableColumnMenu
        hideFooter
        sx={(theme) => ({
          border: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.background.paper,
          minHeight: '100%',
          '.MuiDataGrid-cell': {
            p: theme.spacing(3),
          },
          '.MuiButtonBase-root': {
            p: theme.spacing(0),
          },
          '.MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
            display: 'none',
          },
          '.MuiDataGrid-columnHeaders': {
            backgroundColor: theme.palette.grey[100],
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '.MuiDataGrid-columnHeader': {
            px: theme.spacing(3),
          },
          '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '--DataGrid-overlayHeight': '404px',
        })}
        columns={columns}
        rows={rows}
        rowSelectionModel={selectedPUseId}
        onRowSelectionModelChange={handleRowSelectionChange}
        slots={{
          noRowsOverlay: () => (
            <NoRowsOverlay
              icon={BarChartIcon}
              title='ยังไม่มีข้อมูลสถิติ'
              description='ไม่พบประวัติค่า P เนื่องจากคำถามนี้อาจยังไม่ถูกใช้งาน หรือยังไม่มีการอัปเดตข้อมูลจาก Report'
            />
          ),
        }}
      />
    </Flex>
  );
}
